<template>
  <v-dialog
    width="700"
    v-model="showDialog"
  >
    <template v-slot:activator="{ on }">

      <v-btn
        v-if="isBlocked"
        class="mr-4 mb-4"
        plain
        text
        x-large
        v-on="on"
        color="primary"
      >
        <v-icon class="patient-overview__icon">mdi-account-lock-open</v-icon>
        {{ $ucfirst($t('patient.unblockAccount')) }}
      </v-btn>
    </template>

    <v-card>
      <div class="clearfix">
        <v-btn
          class="pull-right btn-transparent"
          icon
          plain
          @click="showDialog = false"
        >
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </div>
      <div class="pa-5">
        <p class="d-flex justify-space-around pb-5">
          {{ $ucfirst($t('patient.areYouSureToUnblockAccount')) }}
        </p>
        <div class="d-flex justify-space-around pb-5">
          <v-btn
            color="primary"
            outlined
            :x-large="$vuetify.breakpoint.mdAndUp"
            @click="unblockAccount"
          >
            {{ $ucfirst($t('confirm')) }}
          </v-btn>
          <v-btn
            color="primary"
            outlined
            :x-large="$vuetify.breakpoint.mdAndUp"
            @click="showDialog = false"
          >
            {{ $ucfirst($t('buttons.cancel', {catalog: 'app_mobile'})) }}
          </v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * Component UnblockAccountButton.vue
 *
 * @module UnblockAccountButton
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.3] app/src/APP_DASHBOARD/templates/components/Parts/UnblockAccountButton.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'UnblockAccountButton',
  props: {
    patientId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showDialog: false
    }
  },
  computed: {
    isBlocked() {
      return this.$store.getters['patientSummary/isBlocked'];
    }
  },
  methods: {
    async unblockAccount() {
      const data = {
        patientId: this.patientId,
        block: false
      }
      const success = await this.$store.dispatch('patientSummary/toggleBlockAccount', data);

      if (success) {
        this.$toasted.show(this.$ucfirst(this.$t('successMessages.accountUnblocked')), {
          type : 'success',
          icon : 'check',
          position: 'bottom-center',
        });
      }

      this.showDialog = false;
    }
  },
};
</script>
